module.exports = __webpack_public_path__ + "static/media/microsoft_azure.44110412.png";